export default class ParticipantsImportValidation {
  public static createEmpty(): ParticipantsImportValidation {
    return new ParticipantsImportValidation();
  }

  constructor(
    public RowNo: number = 0,
    public Email: string = '',
    public Error: string = '',
  ) {}
}
